/**
 * Where the API lives.
 *
 * In development this is the empty string, so every call stays a same-origin
 * relative path and Vite's proxy (vite.config.ts) forwards it to localhost:8000.
 * In production there is no proxy — the bundle is static files on Cloudflare
 * Pages — so a relative `/api/v1/...` resolves against the Pages domain and
 * gets answered with the SPA's own index.html. The request succeeds, the JSON
 * parse fails, and the page renders as if the database were empty. That is the
 * bug this module exists to prevent, and it cannot reproduce in `npm run dev`.
 *
 * `VITE_API_BASE_URL` still wins when set, so a preview deployment can point at
 * a different backend. The literal is the fallback rather than the mechanism:
 * an env var that fails to load produces exactly the silent breakage above, and
 * a portfolio should not go blank because a build runner dropped a variable.
 *
 * No trailing slash — callers concatenate paths that begin with one.
 */

const PRODUCTION_API = "https://iftikharali-api.onrender.com";

function resolve(): string {
  const configured = import.meta.env.VITE_API_BASE_URL?.trim();
  if (configured) {
    return configured.replace(/\/+$/, "");
  }
  return import.meta.env.DEV ? "" : PRODUCTION_API;
}

export const API_BASE = resolve();
